// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.108.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Voice Orb interface (sable Assistant.presentation_type = "voice_orb") -- proposal
   sable-interfaces-voice-orb.2026-10-12 §4.2. Mobile-viewport-first: this is a voice-first screen,
   the orb is the primary visual, with a minimal text fallback/transcript underneath for
   accessibility and visitors who land without mic/audio permission granted (§4.2's own framing). */

.vo-root {
  min-height: 100vh;
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
  background: #0b0d12;
  color: #f2f3f5;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  --accent: #2f6f7d;
  /* iOS Safari shows the real <html>/<body> background (usually white) during rubber-band
     overscroll bounce, since this root element's own background doesn't extend past its box --
     fixed properly by also blacking out html/body while this page is mounted (see
     VoiceOrbExperience.tsx's own effect for that), this just stops the bounce from happening at
     all so there's nothing to show through in the first place. */
  overscroll-behavior: none;
}

.vo-header {
  position: relative;
  padding: 18px 20px 4px;
  text-align: center;
}

.vo-header-icons {
  position: absolute;
  top: 14px;
  right: 16px;
  display: flex;
  gap: 8px;
}

.vo-icon-btn {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(255, 255, 255, 0.05);
  color: #80848e;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
}

.vo-icon-btn[aria-pressed="true"] {
  color: #f2f3f5;
  border-color: rgba(255, 255, 255, 0.3);
}

.vo-title-btn {
  display: inline-block;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 2px 8px;
}

.vo-header h1 {
  font-size: 19px;
  margin: 4px 0 2px;
}

/* "Glow in and fade out" -- a tappable title reveals the tagline/description for a few seconds,
   a fade (opacity) plus a soft text-shadow bloom rather than an abrupt show/hide. The line's height
   stays reserved at all times so revealing it doesn't shift the rest of the header. */
.vo-tagline {
  font-size: 13px;
  color: #b4b8c2;
  margin: 0;
  min-height: 18px;
  opacity: 0;
  text-shadow: 0 0 0 transparent;
  transition: opacity 0.6s ease, text-shadow 0.6s ease;
  pointer-events: none;
}

.vo-tagline.vo-tagline-visible {
  opacity: 1;
  text-shadow: 0 0 14px rgba(242, 243, 245, 0.35);
}

.vo-stage {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 10px 20px;
}

.vo-canvas-wrap {
  width: min(78vw, 340px);
  height: min(78vw, 340px);
  position: relative;
}

.vo-canvas-wrap canvas {
  width: 100%;
  height: 100%;
  display: block;
}

.vo-state-label {
  font-size: 13px;
  color: #b4b8c2;
  text-align: center;
  min-height: 18px;
}

.vo-mic-icon-btn {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.06);
  color: #f2f3f5;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.vo-mic-icon-btn[aria-pressed="true"] {
  background: var(--accent);
  border-color: var(--accent);
}

.vo-mic-icon-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vo-mic-hint {
  font-size: 12px;
  color: #80848e;
  text-align: center;
  max-width: 280px;
}

.vo-speak-toggle {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #80848e;
}

.vo-transcript {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  max-height: 32vh;
  overflow-y: auto;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.vo-msg {
  font-size: 14px;
  line-height: 1.4;
  max-width: 86%;
  padding: 8px 12px;
  border-radius: 14px;
}

.vo-msg.visitor {
  align-self: flex-end;
  background: var(--accent);
  color: #fff;
}

.vo-msg.assistant {
  align-self: flex-start;
  background: rgba(255, 255, 255, 0.08);
}

.vo-composer {
  display: flex;
  gap: 8px;
  padding: 10px 16px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.vo-composer input {
  flex: 1;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 10px;
  color: #f2f3f5;
  padding: 10px 12px;
  font-size: 14px;
}

.vo-composer input::placeholder {
  color: #80848e;
}

.vo-composer button {
  background: var(--accent);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 0 16px;
  font-size: 14px;
  cursor: pointer;
}

.vo-composer button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.vo-toast {
  text-align: center;
  font-size: 12px;
  color: #ffb199;
  padding: 0 16px 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/voice-orb.css"],"names":[],"mappings":"AAAA;;;mGAGmG;;AAEnG;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,sEAAsE;EACtE,iBAAiB;EACjB;;;;iEAI+D;EAC/D,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;sFAEsF;AACtF;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,8BAA8B;EAC9B,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,+CAA+C;AACjD;;AAEA;EACE,OAAO;EACP,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB","sourcesContent":["/* Voice Orb interface (sable Assistant.presentation_type = \"voice_orb\") -- proposal\n   sable-interfaces-voice-orb.2026-10-12 §4.2. Mobile-viewport-first: this is a voice-first screen,\n   the orb is the primary visual, with a minimal text fallback/transcript underneath for\n   accessibility and visitors who land without mic/audio permission granted (§4.2's own framing). */\n\n.vo-root {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n  background: #0b0d12;\n  color: #f2f3f5;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  --accent: #2f6f7d;\n  /* iOS Safari shows the real <html>/<body> background (usually white) during rubber-band\n     overscroll bounce, since this root element's own background doesn't extend past its box --\n     fixed properly by also blacking out html/body while this page is mounted (see\n     VoiceOrbExperience.tsx's own effect for that), this just stops the bounce from happening at\n     all so there's nothing to show through in the first place. */\n  overscroll-behavior: none;\n}\n\n.vo-header {\n  position: relative;\n  padding: 18px 20px 4px;\n  text-align: center;\n}\n\n.vo-header-icons {\n  position: absolute;\n  top: 14px;\n  right: 16px;\n  display: flex;\n  gap: 8px;\n}\n\n.vo-icon-btn {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  background: rgba(255, 255, 255, 0.05);\n  color: #80848e;\n  font-size: 13px;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n}\n\n.vo-icon-btn[aria-pressed=\"true\"] {\n  color: #f2f3f5;\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.vo-title-btn {\n  display: inline-block;\n  background: none;\n  border: none;\n  color: inherit;\n  cursor: pointer;\n  padding: 2px 8px;\n}\n\n.vo-header h1 {\n  font-size: 19px;\n  margin: 4px 0 2px;\n}\n\n/* \"Glow in and fade out\" -- a tappable title reveals the tagline/description for a few seconds,\n   a fade (opacity) plus a soft text-shadow bloom rather than an abrupt show/hide. The line's height\n   stays reserved at all times so revealing it doesn't shift the rest of the header. */\n.vo-tagline {\n  font-size: 13px;\n  color: #b4b8c2;\n  margin: 0;\n  min-height: 18px;\n  opacity: 0;\n  text-shadow: 0 0 0 transparent;\n  transition: opacity 0.6s ease, text-shadow 0.6s ease;\n  pointer-events: none;\n}\n\n.vo-tagline.vo-tagline-visible {\n  opacity: 1;\n  text-shadow: 0 0 14px rgba(242, 243, 245, 0.35);\n}\n\n.vo-stage {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  padding: 10px 20px;\n}\n\n.vo-canvas-wrap {\n  width: min(78vw, 340px);\n  height: min(78vw, 340px);\n  position: relative;\n}\n\n.vo-canvas-wrap canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n}\n\n.vo-state-label {\n  font-size: 13px;\n  color: #b4b8c2;\n  text-align: center;\n  min-height: 18px;\n}\n\n.vo-mic-icon-btn {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(255, 255, 255, 0.06);\n  color: #f2f3f5;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.vo-mic-icon-btn[aria-pressed=\"true\"] {\n  background: var(--accent);\n  border-color: var(--accent);\n}\n\n.vo-mic-icon-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vo-mic-hint {\n  font-size: 12px;\n  color: #80848e;\n  text-align: center;\n  max-width: 280px;\n}\n\n.vo-speak-toggle {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  color: #80848e;\n}\n\n.vo-transcript {\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  max-height: 32vh;\n  overflow-y: auto;\n  padding: 10px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.vo-msg {\n  font-size: 14px;\n  line-height: 1.4;\n  max-width: 86%;\n  padding: 8px 12px;\n  border-radius: 14px;\n}\n\n.vo-msg.visitor {\n  align-self: flex-end;\n  background: var(--accent);\n  color: #fff;\n}\n\n.vo-msg.assistant {\n  align-self: flex-start;\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.vo-composer {\n  display: flex;\n  gap: 8px;\n  padding: 10px 16px 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.vo-composer input {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.14);\n  border-radius: 10px;\n  color: #f2f3f5;\n  padding: 10px 12px;\n  font-size: 14px;\n}\n\n.vo-composer input::placeholder {\n  color: #80848e;\n}\n\n.vo-composer button {\n  background: var(--accent);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 0 16px;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.vo-composer button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.vo-toast {\n  text-align: center;\n  font-size: 12px;\n  color: #ffb199;\n  padding: 0 16px 8px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
